export default __webpack_public_path__ + "static/media/Helpdesk-Text.de2964fd.png";